module.exports = __webpack_public_path__ + "ed067cfcd25835cfa2611e7d4b347702.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/broschuere20_image.jpg
// module id = 466
// module chunks = 0